module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_22.8d3bb0d3.png";